(function () {
  'use strict';

  if (window.__middoRoktUpsellInit) return;

  var config = window.MIDDO_ROKT_UPSELL;
  if (!config || !config.variantId || !config.offerId) return;

  window.__middoRoktUpsellInit = true;

  var shopifyRoot = (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) ? window.Shopify.routes.root : '/';

  var root = shopifyRoot.slice(-1) === '/'
    ? shopifyRoot
    : shopifyRoot + '/';

  var busy = false;
  var bypassNextSubmit = false;
  var declinedInCurrentPage = false;
  var knownDefaultUpsells = [];
  var stateQueue = Promise.resolve();

  function route(path) {
    return root + String(path).replace(/^\//, '');
  }

  function sameVariantId(value) {
    return String(value) === String(config.variantId);
  }

  function isFalse(value) {
    return value === false || value === 'false';
  }

  function parseDefaultUpsells(rawValue) {
    if (Array.isArray(rawValue)) return rawValue;
    if (typeof rawValue !== 'string' || rawValue.trim() === '') return [];

    try {
      var parsed = JSON.parse(rawValue);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn(
        'Middo: ongeldige AfterSell-winkelwagenstatus.',
        error
      );
      return [];
    }
  }

  function getDefaultUpsells(cart) {
    return parseDefaultUpsells(
      cart && cart.attributes
        ? cart.attributes.defaultUpsells
        : '[]'
    );
  }

  function isOurAfterSellEntry(entry) {
    return Boolean(
      entry &&
      entry.source === 'aftersell' &&
      sameVariantId(entry.variantId)
    );
  }

  function findAfterSellState(entries) {
    for (var index = 0; index < entries.length; index += 1) {
      if (isOurAfterSellEntry(entries[index])) {
        return entries[index];
      }
    }

    return null;
  }

  function setOurAfterSellState(entries, shouldBeAdded) {
    var nextEntries = [];
    var replaced = false;

    entries.forEach(function (entry) {
      if (!isOurAfterSellEntry(entry)) {
        nextEntries.push(entry);
        return;
      }

      if (!replaced) {
        nextEntries.push(
          Object.assign({}, entry, {
            mutatedShouldBeAdded: Boolean(shouldBeAdded),
            source: 'aftersell',
            variantId: String(config.variantId)
          })
        );

        replaced = true;
      }
    });

    if (!replaced) {
      nextEntries.push({
        mutatedShouldBeAdded: Boolean(shouldBeAdded),
        source: 'aftersell',
        variantId: String(config.variantId)
      });
    }

    return nextEntries;
  }

  function removeOurAfterSellState(entries) {
    return entries.filter(function (entry) {
      return !isOurAfterSellEntry(entry);
    });
  }

  function enqueueStateTask(task) {
    var job = stateQueue.then(task, task);

    stateQueue = job.catch(function () {
      /*
       * Houd de wachtrij bruikbaar wanneer
       * één achtergrondtaak mislukt.
       */
    });

    return job;
  }

  async function readJsonResponse(response, fallbackMessage) {
    var data = null;

    try {
      data = await response.json();
    } catch (error) {
      /*
       * De HTTP-status blijft leidend wanneer
       * Shopify geen JSON terugstuurt.
       */
    }

    if (!response.ok) {
      var message = (
        data &&
        (
          data.description ||
          data.message ||
          data.errors
        )
      ) || fallbackMessage;

      throw new Error(String(message));
    }

    return data;
  }

  async function getCart() {
    var response = await fetch(route('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    return readJsonResponse(
      response,
      'Kon de winkelwagen niet ophalen.'
    );
  }

  async function updateCart(payload, keepalive) {
    var response = await fetch(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: Boolean(keepalive),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    return readJsonResponse(
      response,
      'Kon de winkelwagen niet bijwerken.'
    );
  }

  async function addProtectionProduct() {
    var response = await fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: config.variantId,
            quantity: 1,
            properties: {
              __as_offer_id: config.offerId
            }
          }
        ]
      })
    });

    return readJsonResponse(
      response,
      'Kon de premium verzendbescherming niet toevoegen.'
    );
  }

  function getProtectionLines(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    return cart.items.filter(function (item) {
      return sameVariantId(item.variant_id);
    });
  }

  function isCorrectAfterSellLine(line) {
    return Boolean(
      line &&
      line.properties &&
      String(
        line.properties.__as_offer_id || ''
      ) === String(config.offerId)
    );
  }

  function buildRemovalUpdates(lines) {
    var updates = {};

    lines.forEach(function (line) {
      if (line && line.key) {
        updates[line.key] = 0;
      }
    });

    return updates;
  }

  function hasOwnKeys(object) {
    return Boolean(
      object &&
      Object.keys(object).length > 0
    );
  }

  function sameJson(left, right) {
    return JSON.stringify(left) === JSON.stringify(right);
  }

  async function resetAfterSellState() {
    declinedInCurrentPage = false;
    knownDefaultUpsells = [];

    await updateCart(
      {
        attributes: {
          defaultUpsells: '[]'
        }
      },
      true
    );
  }

  async function markProtectionAsDeclined() {
    declinedInCurrentPage = true;

    /*
     * Lees de actuele winkelwagenstatus pas nadat
     * het thema de verwijdering heeft uitgevoerd.
     * Zo blijven eventuele andere AfterSell-items behouden.
     */
    var cart = await getCart();
    var entries = getDefaultUpsells(cart);

    var declinedEntries = setOurAfterSellState(
      entries,
      false
    );

    if (!sameJson(entries, declinedEntries)) {
      await updateCart(
        {
          attributes: {
            defaultUpsells: JSON.stringify(
              declinedEntries
            )
          }
        },
        true
      );
    }

    knownDefaultUpsells = declinedEntries;
  }

  async function normalizeDeclinedCart(
    cart,
    entries,
    protectionLines
  ) {
    var declinedEntries = setOurAfterSellState(
      entries,
      false
    );

    var payload = {};

    if (protectionLines.length > 0) {
      payload.updates = buildRemovalUpdates(
        protectionLines
      );
    }

    if (!sameJson(entries, declinedEntries)) {
      payload.attributes = {
        defaultUpsells: JSON.stringify(
          declinedEntries
        )
      };
    }

    if (hasOwnKeys(payload)) {
      await updateCart(payload, false);
    }

    knownDefaultUpsells = declinedEntries;
  }

  async function prepareCartForCheckout() {
    /*
     * Wacht alleen op een reeds gestarte
     * winkelwagenstatus-update.
     */
    await stateQueue;

    var cart = await getCart();
    var entries = getDefaultUpsells(cart);
    var state = findAfterSellState(entries);
    var protectionLines = getProtectionLines(cart);

    knownDefaultUpsells = entries;

    /*
     * Een handmatige verwijdering op de huidige
     * winkelpagina heeft voorrang.
     */
    if (declinedInCurrentPage) {
      await normalizeDeclinedCart(
        cart,
        entries,
        protectionLines
      );

      return;
    }

    var correctLines = protectionLines.filter(
      isCorrectAfterSellLine
    );

    var correctLine = correctLines.length > 0
      ? correctLines[0]
      : null;

    /*
     * We schrijven vóór checkout nooit
     * mutatedShouldBeAdded: true.
     *
     * De aanwezige productregel zorgt ervoor
     * dat de AfterSell-checkbox geselecteerd verschijnt.
     *
     * Een geforceerde true-status kan wedijveren
     * met de verwijderactie van AfterSell en de
     * checkbox ongewenst opnieuw aanzetten.
     */
    var neutralEntries = setOurAfterSellState(
      entries,
      false
    );

    if (protectionLines.length > 0) {
      var lineUpdates = {};

      if (correctLine) {
        protectionLines.forEach(function (line) {
          if (!line || !line.key) return;

          if (line.key === correctLine.key) {
            if (Number(line.quantity) !== 1) {
              lineUpdates[line.key] = 1;
            }
          } else {
            lineUpdates[line.key] = 0;
          }
        });
      } else {
        lineUpdates = buildRemovalUpdates(
          protectionLines
        );
      }

      var normalizePayload = {};

      if (hasOwnKeys(lineUpdates)) {
        normalizePayload.updates = lineUpdates;
      }

      if (!sameJson(entries, neutralEntries)) {
        normalizePayload.attributes = {
          defaultUpsells: JSON.stringify(
            neutralEntries
          )
        };
      }

      if (hasOwnKeys(normalizePayload)) {
        await updateCart(
          normalizePayload,
          false
        );
      }

      knownDefaultUpsells = neutralEntries;

      if (correctLine) {
        return;
      }

      /*
       * Er stond alleen een oude of verkeerd
       * gemarkeerde beschermingsregel in de cart.
       */
      try {
        await addProtectionProduct();
      } catch (error) {
        var retryEntries = removeOurAfterSellState(
          neutralEntries
        );

        try {
          await updateCart(
            {
              attributes: {
                defaultUpsells: JSON.stringify(
                  retryEntries
                )
              }
            },
            false
          );
        } catch (rollbackError) {
          console.warn(
            'Middo: herstelstatus kon niet worden teruggedraaid.',
            rollbackError
          );
        }

        throw error;
      }

      return;
    }

    /*
     * Er is geen beschermingsregel aanwezig,
     * maar er bestaat al een AfterSell-status
     * voor deze winkelwagen.
     *
     * Dat betekent dat de klant hem eerder heeft
     * verwijderd of uitgevinkt. We respecteren
     * daarom de afwezige cartregel.
     */
    if (state) {
      if (
        !isFalse(state.mutatedShouldBeAdded) ||
        !sameJson(entries, neutralEntries)
      ) {
        await updateCart(
          {
            attributes: {
              defaultUpsells: JSON.stringify(
                neutralEntries
              )
            }
          },
          false
        );
      }

      knownDefaultUpsells = neutralEntries;
      return;
    }

    /*
     * Dit is een nieuwe winkelwagen zonder eerdere keuze.
     * Leg eerst de neutrale AfterSell-status vast en voeg
     * vervolgens exact één gemarkeerde productregel toe.
     */
    await updateCart(
      {
        attributes: {
          defaultUpsells: JSON.stringify(
            neutralEntries
          )
        }
      },
      false
    );

    knownDefaultUpsells = neutralEntries;

    try {
      await addProtectionProduct();
    } catch (error) {
      var cleanEntries = removeOurAfterSellState(
        neutralEntries
      );

      try {
        await updateCart(
          {
            attributes: {
              defaultUpsells: JSON.stringify(
                cleanEntries
              )
            }
          },
          false
        );
      } catch (rollbackError) {
        console.warn(
          'Middo: mislukte toevoeging kon niet volledig worden teruggedraaid.',
          rollbackError
        );
      }

      throw error;
    }
  }

  function continueNativeCheckout(
    form,
    submitter,
    originalDisabled
  ) {
    submitter.disabled = originalDisabled;
    busy = false;
    bypassNextSubmit = true;

    if (
      typeof form.requestSubmit === 'function'
    ) {
      try {
        form.requestSubmit(submitter);
        return;
      } catch (error) {
        console.warn(
          'Middo: native checkout-submit kon niet worden hervat.',
          error
        );
      }
    }

    window.location.assign(
      route('checkout')
    );
  }

  /*
   * Het Enterprise-thema vuurt dit event alleen
   * af na een echte wijziging van de winkelwagen.
   *
   * Er worden dus geen polling, setInterval of
   * MutationObserver gebruikt.
   */
  document.addEventListener(
    'on:line-item:change',
    function (event) {
      var cartItems = event.target;

      if (
        !cartItems ||
        typeof cartItems.matches !== 'function' ||
        !cartItems.matches('cart-items')
      ) {
        return;
      }

      var detail = event.detail || {};

      /*
       * De volledige winkelwagen is leeg.
       * Een nieuwe winkelwagen mag de bescherming
       * opnieuw standaard selecteren.
       */
      if (
        cartItems.dataset.empty === 'true'
      ) {
        enqueueStateTask(
          resetAfterSellState
        ).catch(function (error) {
          console.warn(
            'Middo: lege winkelwagenstatus kon niet worden gereset.',
            error
          );
        });

        return;
      }

      /*
       * Alleen de verzendbescherming is uit een
       * nog gevulde winkelwagen verwijderd.
       */
      if (
        sameVariantId(detail.variantId) &&
        Number(detail.newQuantity) === 0
      ) {
        enqueueStateTask(
          markProtectionAsDeclined
        ).catch(function (error) {
          console.warn(
            'Middo: afwijzing van verzendbescherming kon niet worden opgeslagen.',
            error
          );
        });
      }
    }
  );

  var initialRawState =
    config.initialDefaultUpsells;

  var initialEntries = parseDefaultUpsells(
    initialRawState
  );

  knownDefaultUpsells = initialEntries;

  var initialStateHasValue = (
    typeof initialRawState === 'string' &&
    initialRawState.trim() !== '' &&
    initialRawState.trim() !== '[]'
  );

  /*
   * Fallback wanneer een winkelwagen buiten de
   * normale Enterprise-events om is leeggemaakt.
   *
   * Alleen in die uitzonderingssituatie wordt
   * bij paginalaad één kleine update uitgevoerd.
   */
  if (
    Number(config.initialCartItemCount) === 0 &&
    initialStateHasValue
  ) {
    enqueueStateTask(
      resetAfterSellState
    ).catch(function (error) {
      console.warn(
        'Middo: verouderde lege winkelwagenstatus kon niet worden gereset.',
        error
      );
    });
  }

  /*
   * Luister naar de native Shopify-formsubmit.
   * Dit ondersteunt muis, toetsenbord en bestaande
   * themavalidatie.
   */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (
        !form ||
        (
          form.id !== 'cart' &&
          form.id !== 'cart-drawer-form'
        )
      ) {
        return;
      }

      var submitter =
        event.submitter ||
        form.querySelector(
          'button[name="checkout"]'
        ) ||
        document.querySelector(
          'button[name="checkout"][form="' +
          form.id +
          '"]'
        );

      if (
        !submitter ||
        submitter.name !== 'checkout'
      ) {
        return;
      }

      /*
       * De tweede submit is de hervatting van
       * de oorspronkelijke checkoutactie.
       */
      if (bypassNextSubmit) {
        bypassNextSubmit = false;
        return;
      }

      /*
       * Laat eerdere themavalidatie,
       * bijvoorbeeld akkoord met voorwaarden,
       * altijd voorgaan.
       */
      if (event.defaultPrevented) {
        return;
      }

      event.preventDefault();

      if (busy) return;

      busy = true;

      var originalDisabled =
        submitter.disabled;

      submitter.disabled = true;

      prepareCartForCheckout()
        .catch(function (error) {
          /*
           * Een technische fout mag de normale
           * Shopify-checkout nooit blokkeren.
           */
          console.error(
            'Middo AfterSell checkoutvoorbereiding mislukt:',
            error
          );
        })
        .then(function () {
          continueNativeCheckout(
            form,
            submitter,
            originalDisabled
          );
        });
    }
  );
})();